module.exports = __webpack_public_path__ + "static/8-e138e50b9f2e1d6905260076bf0ec45f.jpg";